// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"2afa5843","693":"fbca34be","710":"c2c7deb0","845":"49513a7c","850":"da9fe32c","983":"6b9d1678"}[chunkId] + ".chunk.js";
};